import { createFileRoute, redirect } from '@tanstack/react-router'
import { withRoutePermissions } from '~/utils/rbac'

// Chaque onglet est une URL distincte ; /categories redirige vers l'onglet par défaut
// (« Catégories ») directement au chargement de la route.
export const Route = createFileRoute('/_authenticated/categories/')({
  staticData: {
    permission: ['read', 'categories'],
  },
  beforeLoad: () => {
    throw redirect({ to: '/categories/categories' })
  },
})
withRoutePermissions(Route)
